import { SingleFilter } from "./single-filter.model";

/**Operatori possibili per combinare i filtri */
export enum operatorValue {
    and = 'AND',
    or = 'OR'
}

/**Interfaccia per filtri complessi */
export interface OperatorFilter {
    /**tipo di operatore da applicare alla lista di filtri */
    operator: operatorValue;
    /**lista di filtri che possono essere SingleFilter o OperatorFilter */
    filters: (SingleFilter | OperatorFilter)[];
}